export const AQA_STOP_SLIDER: string = 'aqaStopSlider';
